import { Type } from "class-transformer";
import { observable } from "mobx";
import type TransferType from "./transferType";
import BankExportDownloadResponse from "./bankExportDownloadResponse";

export class Action {
  @Type(() => Date)
  actionAt: Date;

  actionBy: string;

  description: string;
}

export interface IBankExport {
  id: string;
  name: string;
  createdAt: Date;
  lastDownloadedAt?: Date;
  lastDownloadedBy?: string;
}

export interface IBankExportDetail {
  id: string;
  name: string;
  createdAt: Date;
  createdBy: string;
  downloads: BankExportDownloadResponse[];
  paymentsIncludedCount: number;
}

export default class BankExport implements IBankExport, IBankExportDetail {
  id: string;

  name: string;

  refundType?: TransferType;

  @Type(() => Date)
  createdAt: Date;

  createdBy: string;

  lastDownloadedBy: string;

  @Type(() => Date)
  lastDownloadedAt: Date;

  paymentsIncludedCount: number;

  @Type(() => BankExportDownloadResponse)
  @observable
  downloads: BankExportDownloadResponse[] = [];
}
